/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ID } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';

export const JobSharedDocType = createEnum('SHARED_DOCS_TYPE', {
  Contract: 1,
  Specification: 2,
  Plans: 3,
  ColorSelection: 4,
  ChangeOrderQuotations: 5,
  JobLetters: 6,
});

export type JobSharedDocType = EnumSet<typeof JobSharedDocType>;

export type JobSharedDocListItemDto = {
  id: ID;
  name: string;
  sharedDate: Date;
  sharedBy: string;
  docType: JobSharedDocType;
};

export type JobSharedDocNewSetListItemDto = {
  googleFileId: ID;
  googleFileName: string;
};

export type JobSharedDocNewSetDto = {
  type: JobSharedDocType;
  files: JobSharedDocNewSetListItemDto[];
};
